import { render, staticRenderFns } from "./cModalExpense.vue?vue&type=template&id=c08e9072&scoped=true"
import script from "./cModalExpense.vue?vue&type=script&lang=js"
export * from "./cModalExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08e9072",
  null
  
)

export default component.exports